module.exports = __webpack_public_path__ + "static/shot3-3a6589c9ff7a62ab266b94568d419357.png";